package com.xtream.composeapp.platform

actual val currentPlatform: PlatformType
    get() =  PlatformType.WEB